import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import UseIsAIEnabledForContentQuery, {
	type useIsAIEnabledForContentQuery$data,
	type useIsAIEnabledForContentQuery$variables,
} from '../../hooks/__generated__/useIsAIEnabledForContentQuery.graphql';

export function preloadUseIsAIEnabledForContentQuery(contentId: string) {
	return query<useIsAIEnabledForContentQuery$data, useIsAIEnabledForContentQuery$variables>({
		query: UseIsAIEnabledForContentQuery,
		variables: {
			contentId,
		},
	});
}
